// L'interrogation de /news-radar-data/, partagée par les deux vues de la page
// « Veille globale ».
//
// Le tableau et le fil consomment la même requête avec les mêmes filtres ;
// seul le traitement de la réponse diffère (le tableau remplace sa page, le
// fil empile et gère le défilement infini). Les paramètres étaient donc
// dupliqués mot pour mot des deux côtés — au point qu'il a fallu ajouter
// `media_type` deux fois. Ils vivent maintenant ici.
import { computed } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

export default function useNewsRadarDataQuery() {
  const { axiosGet } = useAxios();
  const { store } = useProxy();

  const applyFilters = computed(() => store.getters["common/getApplyFilters"]);
  const site = computed(() => store.getters["newsRadar/getSites"]);
  const sources = computed(() => store.getters["newsRadar/getSources"]);
  const origins = computed(() => store.getters["newsRadar/getOrigins"]);
  const configs = computed(() => store.getters["newsRadar/getConfigs"]);
  const scoreMin = computed(() => store.getters["newsRadar/getScoreMin"]);
  const startDate = computed(() => store.getters["newsRadar/getDates"][0]);
  const endDate = computed(() => store.getters["newsRadar/getDates"][1]);
  const mediaType = computed(
    () => store.getters["newsRadar/getMediaType"] || "written"
  );

  const hasValidDates = () =>
    Boolean(
      startDate.value &&
        startDate.value.length === 10 &&
        endDate.value &&
        endDate.value.length === 10
    );

  const fetchPage = async ({ page, limit }) => {
    const {
      data: { total, items },
    } = await axiosGet("/news-radar-data/", {
      ...(site.value ? { site_id: site.value } : {}),
      ...(sources.value ? { source_ids: sources.value.join(",") } : {}),
      ...(origins.value ? { origins: origins.value.join(",") } : {}),
      ...(configs.value ? { config_ids: configs.value.join(",") } : {}),
      ...(scoreMin.value != null ? { score_min: scoreMin.value } : {}),
      start_date: startDate.value,
      end_date: endDate.value,
      page,
      limit,
      // Envoyé même sans site : l'API l'ignore alors, faute de savoir quelle
      // config consulter, et rend les deux supports mélangés. C'est le tag de
      // chaque ligne (`media_types`) qui dit ce qu'on regarde.
      media_type: mediaType.value,
    });

    return { total, items };
  };

  return {
    applyFilters,
    endDate,
    fetchPage,
    hasValidDates,
    mediaType,
    startDate,
  };
}
